<template>
  <v-app id="app" class="page-wraper">
      <app-header/>
      <!--    <transition-->
      <!--        enter-active-class="animate__animated animate__slideInUp"-->
      <!--        leave-active-class="animate__animated animate__slideInDown"-->
      <!--        mode="out-in">-->
      <!--      <router-view/>-->
      <!--    </transition>-->
      <router-view/>
      <app-footer/>
  </v-app>
</template>

<script>
import Header from './components/shared/Header'
import Footer from './components/shared/Footer'
import Accueil from './components/accueil/index'
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: 'App',
  components: {
    AppHeader: Header,
    AppFooter: Footer,
    AppAccueil: Accueil,
  },
  data(){
    return{}
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([]),
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss">
@import "assets/css/customized/root";
@import "assets/css/customized/colors";
@import "assets/css/customized/bgColors";
@import "assets/css/customized/buttons";
@import url(https://fonts.googleapis.com/css?family=Roboto+Condensed:400|Roboto:100);

.animate__animated{
  --animate-duration: 0.5s;
}
#nprogress .bar {
  background: var(--color-seventeenth, rgba(34, 134, 195, 1));
  height: 4px;
}
#app{}
.font-weight-bold{
  font-weight: bold;
}
.cursor-not-allowed{
  cursor: not-allowed !important;
}
.cursor-text{
  cursor: text !important;
}
/* Start Colors */
// color variables

// background-image gradient classes
/* End Colors */
</style>



// WEBPACK FOOTER //
// src/App.vue